import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';
import Gallery from '../pages/Documents/Gallery';
import ProtectedRoute from '../sections/auth/ProtectedRoute';
import TravelUpdate from '../pages/Reports/TravelUpdate/TravelUpdate';
import AdminApproval from '../pages/Approvals/AdminApproval';
import CompanyList from '../pages/Admin-IAM/Company/CompnayList';
import IamList from '../pages/Admin-IAM/IAM/IamList';
import RegionList from '../pages/MasterData/RegionMaster/RegionList';
import TerritoryList from '../pages/MasterData/TerritoryMaster/TerritoryList';
import RegionForm from '../pages/MasterData/RegionMaster/RegionForm';
import TerritoryForm from '../pages/MasterData/TerritoryMaster/TerritoryForm';
import DailyAttendance from '../pages/Reports/AttendanceReport/DailyAttendance';
import SalesOrderApproval from '../pages/Orders/SalesOrderApproval/SalesOrderApproval';
import DistributorForm from '../pages/MasterData/DistributorMaster/DistributorForm';

// render - Dashboard
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard/default')));

// User Master
const EmployeeList = Loadable(lazy(() => import('pages/UserMaster/EmployeeMaster/EmployeeList')));
const EmployeeFormPage = Loadable(lazy(() => import('pages/UserMaster/EmployeeMaster/EmployeeFormPage')));
const MdoList = Loadable(lazy(() => import('pages/UserMaster/MdoMaster/MdoList')));
const MdoForm = Loadable(lazy(() => import('pages/UserMaster/MdoMaster/MdoForm')));

// Master Data
const DistributorList = Loadable(lazy(() => import('pages/MasterData/DistributorMaster/DistributorList')));
const FarmerList = Loadable(lazy(() => import('pages/MasterData/FarmerMaster/FarmerList')));
const RetailerList = Loadable(lazy(() => import('pages/MasterData/RetailerMaster/RetailerList')));
const ProductList = Loadable(lazy(() => import('pages/MasterData/ProductMaster/ProductList')));
const ProductForm = Loadable(lazy(() => import('pages/MasterData/ProductMaster/ProductForm')));
const LocationMaster = Loadable(lazy(() => import('pages/MasterData/LocationMaster/LocationMaster')));

// Reports
const AttendanceReport = Loadable(lazy(() => import('pages/Reports/AttendanceReport/AttendanceReport')));
const ExpenseReport = Loadable(lazy(() => import('pages/Reports/ExpenseReport/ExpenseReport')));
const TravelReport = Loadable(lazy(() => import('pages/Reports/TravelReport/TravelReport')));

// Approvals
const ExpenseApproval = Loadable(lazy(() => import('pages/Approvals/ExpenseApproval')));
const L2ExpenseApproval = Loadable(lazy(() => import('pages/Approvals/L2ExpenseApproval')));

// ==============================|| MAIN ROUTING ||============================== //

const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
const roleID = userInfo?.roleID;

const MainRoutes = {
  path: '/',
  element: (
    <ProtectedRoute>
      <DashboardLayout />
    </ProtectedRoute>
  ),
  children: [
    {
      path: '/',
      element: <DashboardDefault />
    },
    {
      path: '/employee-master',
      element: <EmployeeList />
    },
    {
      path: '/add-employee',
      element: <EmployeeFormPage />
    },
    {
      path: '/third-party',
      element: <MdoList />
    },
    {
      path: '/add-mdo',
      element: <MdoForm />
    },
    {
      path: '/distributor-master',
      element: <DistributorList />
    },
     { path: '/add-distirbutor',
      element: <DistributorForm/>
    },
    {
      path: '/retailer-master',
      element: <RetailerList />
    },
    {
      path: '/farmer-master',
      element: <FarmerList />
    },
    {
      path: '/product-master',
      element: <ProductList />
    },
    {
      path: '/location-master',
      element: <LocationMaster />
    },
    {
      path: '/region-master',
      element: <RegionList />
    },
    {
      path: '/add-region',
      element: <RegionForm />
    },
    {
      path: '/add-territory',
      element: <TerritoryForm />
    },
    {
      path: '/territory-master',
      element: <TerritoryList />
    },
    {
      path: '/add-product',
      element: <ProductForm />
    },
    {
      path: '/attendance-report',
      element: <AttendanceReport />
    },
    {
      path: '/expense-report',
      element: <ExpenseReport />
    },
    {
      path: '/travel-update',
      element: <TravelUpdate />
    },
    {
      path: '/travel-report',
      element: <TravelReport />
    },
    {
      path: '/handbook',
      element: <Gallery />
    },
    {
      path: '/daily-attendance',
      element: <DailyAttendance />
    },
    {
      path: '/sales-order-approval',
      element: <SalesOrderApproval />
    },
    ...(roleID === 1
      ? []
      : [
          {
            path: '/expense-approval',
            element: <ExpenseApproval />
          },
          {
            path: '/l2expense-approval',
            element: <L2ExpenseApproval />
          },
          {
            path: '/admin-expense-approval',
            element: <AdminApproval />
          }
        ])

    //  {
    //   path: '/company',
    //   element: <CompanyList />
    // },
    //  {
    //   path: '/iam',
    //   element: <IamList />
    // },
  ]
};

export default MainRoutes;





// import { lazy } from 'react';

// // project imports
// import Loadable from 'components/Loadable';
// import DashboardLayout from 'layout/Dashboard';
// import Gallery from '../pages/Documents/Gallery';
// import ProtectedRoute from '../sections/auth/ProtectedRoute';
// import TravelUpdate from '../pages/Reports/TravelUpdate/TravelUpdate';
// import AdminApproval from '../pages/Approvals/AdminApproval';
// import CompanyList from '../pages/Admin-IAM/Company/CompnayList';
// import IamList from '../pages/Admin-IAM/IAM/IamList';
// import RegionList from '../pages/MasterData/RegionMaster/RegionList';
// import TerritoryList from '../pages/MasterData/TerritoryMaster/TerritoryList';
// import RegionForm from '../pages/MasterData/RegionMaster/RegionForm';
// import TerritoryForm from '../pages/MasterData/TerritoryMaster/TerritoryForm';

// // render - Dashboard
// const DashboardDefault = Loadable(lazy(() => import('pages/dashboard/default')));

// // User Master
// const EmployeeList = Loadable(lazy(() => import('pages/UserMaster/EmployeeMaster/EmployeeList')));
// const EmployeeFormPage = Loadable(lazy(() => import('pages/UserMaster/EmployeeMaster/EmployeeFormPage')));
// const MdoList = Loadable(lazy(() => import('pages/UserMaster/MdoMaster/MdoList')));
// const MdoForm = Loadable(lazy(() => import('pages/UserMaster/MdoMaster/MdoForm')));

// // Master Data
// const DistributorList = Loadable(lazy(() => import('pages/MasterData/DistributorMaster/DistributorList')));
// const FarmerList = Loadable(lazy(() => import('pages/MasterData/FarmerMaster/FarmerList')));
// const RetailerList = Loadable(lazy(() => import('pages/MasterData/RetailerMaster/RetailerList')));
// const ProductList = Loadable(lazy(() => import('pages/MasterData/ProductMaster/ProductList')));
// const ProductForm = Loadable(lazy(() => import('pages/MasterData/ProductMaster/ProductForm')));
// const LocationMaster = Loadable(lazy(() => import('pages/MasterData/LocationMaster/LocationMaster')));

// // Reports
// const AttendanceReport = Loadable(lazy(() => import('pages/Reports/AttendanceReport/AttendanceReport')));
// const ExpenseReport = Loadable(lazy(() => import('pages/Reports/ExpenseReport/ExpenseReport')));
// const TravelReport = Loadable(lazy(() => import('pages/Reports/TravelReport/TravelReport')));

// // Approvals
// const ExpenseApproval = Loadable(lazy(() => import('pages/Approvals/ExpenseApproval')));
// const L2ExpenseApproval = Loadable(lazy(() => import('pages/Approvals/L2ExpenseApproval')));

// // ==============================|| MAIN ROUTING ||============================== //

// // ✅ Safely fetch user info and roleID
// const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
// const roleID = userInfo?.roleID;

// // ==============================|| ROUTE LOGIC ||============================== //

// let children = [];

// if (roleID == 1) {
//   // 🔹 Admin routes (full access)
//   children = [
//     { path: '/', element: <DashboardDefault /> },
//     { path: '/employee-master', element: <EmployeeList /> },
//     { path: '/add-employee', element: <EmployeeFormPage /> },
//     { path: '/third-party', element: <MdoList /> },
//     { path: '/add-mdo', element: <MdoForm /> },
//     { path: '/distributor-master', element: <DistributorList /> },
//     { path: '/retailer-master', element: <RetailerList /> },
//     { path: '/farmer-master', element: <FarmerList /> },
//     { path: '/product-master', element: <ProductList /> },
//     { path: '/add-product', element: <ProductForm /> },
//     { path: '/location-master', element: <LocationMaster /> },
//     { path: '/region-master', element: <RegionList /> },
//     { path: '/add-region', element: <RegionForm /> },
//     { path: '/territory-master', element: <TerritoryList /> },
//     { path: '/add-territory', element: <TerritoryForm /> },
//     { path: '/attendance-report', element: <AttendanceReport /> },
//     { path: '/expense-report', element: <ExpenseReport /> },
//     { path: '/travel-update', element: <TravelUpdate /> },
//     { path: '/travel-report', element: <TravelReport /> },
//     { path: '/handbook', element: <Gallery /> },
//     // { path: '/company', element: <CompanyList /> },
//     // { path: '/iam', element: <IamList /> }
//   ];
// } else {
//   // 🔹 Other roles: approval-only access
//   children = [
//     { path: '/', element: <DashboardDefault /> },
//     { path: '/expense-approval', element: <ExpenseApproval /> },
//     { path: '/l2expense-approval', element: <L2ExpenseApproval /> },
//     { path: '/admin-expense-approval', element: <AdminApproval /> }
//   ];
// }

// const MainRoutes = {
//   path: '/',
//   element: (
//     <ProtectedRoute>
//       <DashboardLayout />
//     </ProtectedRoute>
//   ),
//   children
// };

// export default MainRoutes;
